export default "__VITE_ASSET__BaXi1Fh3__"